import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-Developer-TranslationQueue', [
  'heading',
  'healthStrip',
  'bridge',
  'banner',
  'batchBanner',
  'courseGroup',
  'rowCancelButton',
  'flushButton',
  'flushDialog',
]);
